"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _reactRouterDom = require("react-router-dom");
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var styles = {
  "documentation-button": "DocumentationButton__documentation-button__3iU4_",
  "documentationButton": "DocumentationButton__documentation-button__3iU4_",
  "wide-button": "DocumentationButton__wide-button__3axll",
  "wideButton": "DocumentationButton__wide-button__3axll",
  "icon": "DocumentationButton__icon__1UbUR"
}; 
require('./DocumentationButton.css');
var buttonStyles = _Button.default.themes.DefaultTheme;
var DocumentationButton = function DocumentationButton(_ref) {
  var icon = _ref.icon,
    linkURL = _ref.linkURL,
    testId = _ref.testId,
    description = _ref.description,
    tooltipText = _ref.tooltipText,
    children = _ref.children;
  return tooltipText ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: tooltipText,
    position: "botton"
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
    role: "button",
    "data-test-id": testId,
    "aria-describedby": "".concat(testId, "-description"),
    "aria-label": "Go to ".concat(children, " mode"),
    className: (0, _classnames.default)(styles.wideButton, styles.documentationButton, buttonStyles.button, buttonStyles.md),
    to: linkURL
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon,
    "data-test-id": "".concat(testId, "-icon")
  }, icon), children, /*#__PURE__*/_react.default.createElement("span", {
    id: "".concat(testId, "-description"),
    className: "visually-hidden",
    "data-test-id": "".concat(testId, "-description")
  }, description))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, _react.default.createElement(_reactRouterDom.Link, {
    role: "button",
    "data-test-id": testId,
    "aria-describedby": "".concat(testId, "-description"),
    "aria-label": "Go to ".concat(children, " mode"),
    className: (0, _classnames.default)(styles.wideButton, styles.documentationButton, buttonStyles.button, buttonStyles.md),
    to: linkURL
  }, _react.default.createElement(_Icon.default, {
    size: "s",
    className: styles.icon,
    "data-test-id": "".concat(testId, "-icon")
  }, icon), children, _react.default.createElement("span", {
    id: "".concat(testId, "-description"),
    className: "visually-hidden",
    "data-test-id": "".concat(testId, "-description")
  }, description)));
};
var _default = exports.default = DocumentationButton;
//# sourceMappingURL=DocumentationButton.js.map